import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import {
  getGetterAccounts as getAccountsApi,
  addGetterAccount as addAccountApi,
  updateGetterAccount as updateAccountApi,
  deleteGetterAccount as deleteAccountApi,
  loginGetterAccount as loginAccountApi,
  runGetterForTask as runTaskApi,
  stopGetterForTask as stopTaskApi,
  getGetterTaskStatus as getTaskStatusApi,
  getGetterJobs as getJobsApi,
} from "../../helpers/getter_helper";

const fail = (rejectWithValue) => (error) =>
  rejectWithValue(error && error.message ? error.message : String(error));

/* ── Аватарууд ── */
export const getGetterAccounts = createAsyncThunk(
  "getter/getAccounts",
  async (platform, { rejectWithValue }) => {
    try {
      return await getAccountsApi(platform);
    } catch (e) {
      return fail(rejectWithValue)(e);
    }
  }
);

export const addGetterAccount = createAsyncThunk(
  "getter/addAccount",
  async (data, { rejectWithValue }) => {
    try {
      const r = await addAccountApi(data);
      toast.success("Аватар нэмэгдлээ", { autoClose: 3000 });
      return r;
    } catch (e) {
      toast.error("Аватар нэмэхэд алдаа гарлаа!", { autoClose: 3000 });
      return fail(rejectWithValue)(e);
    }
  }
);

export const updateGetterAccount = createAsyncThunk(
  "getter/updateAccount",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const r = await updateAccountApi(id, data);
      toast.success("Аватар шинэчлэгдлээ", { autoClose: 3000 });
      return r;
    } catch (e) {
      toast.error("Аватар шинэчлэхэд алдаа гарлаа!", { autoClose: 3000 });
      return fail(rejectWithValue)(e);
    }
  }
);

export const deleteGetterAccount = createAsyncThunk(
  "getter/deleteAccount",
  async (id, { rejectWithValue }) => {
    try {
      await deleteAccountApi(id);
      toast.success("Аватар устлаа", { autoClose: 3000 });
      return id;
    } catch (e) {
      toast.error("Аватар устгахад алдаа гарлаа!", { autoClose: 3000 });
      return fail(rejectWithValue)(e);
    }
  }
);

export const loginGetterAccount = createAsyncThunk(
  "getter/loginAccount",
  async (id, { rejectWithValue }) => {
    try {
      const r = await loginAccountApi(id);
      toast.info("Chrome нээгдэж байна. 2FA гарвал гараар баталгаажуулна уу.", { autoClose: 6000 });
      return r;
    } catch (e) {
      toast.error("Нэвтрэлт эхлүүлэхэд алдаа гарлаа!", { autoClose: 3000 });
      return fail(rejectWithValue)(e);
    }
  }
);

/* ── Судалгаа ажиллуулах (Нэгдсэн судалгаа → Удирдлага дээрх Task) ── */
export const getGetterTaskStatus = createAsyncThunk(
  "getter/getTaskStatus",
  async (_, { rejectWithValue }) => {
    try {
      return await getTaskStatusApi();
    } catch (e) {
      return fail(rejectWithValue)(e);
    }
  }
);

export const runGetterForTask = createAsyncThunk(
  "getter/runTask",
  async (taskId, { rejectWithValue }) => {
    try {
      const r = await runTaskApi(taskId);
      toast.success("Цуглуулалт эхэллээ", { autoClose: 3000 });
      return { taskId, ...r };
    } catch (e) {
      toast.error(e && e.message ? e.message : "Эхлүүлэхэд алдаа гарлаа!", { autoClose: 4000 });
      return fail(rejectWithValue)(e);
    }
  }
);

export const stopGetterForTask = createAsyncThunk(
  "getter/stopTask",
  async (taskId, { rejectWithValue }) => {
    try {
      await stopTaskApi(taskId);
      toast.info("Цуглуулалт зогслоо", { autoClose: 3000 });
      return taskId;
    } catch (e) {
      toast.error("Зогсооход алдаа гарлаа!", { autoClose: 3000 });
      return fail(rejectWithValue)(e);
    }
  }
);

/* ── Ажил / нийтлэл / статистик ── */
export const getGetterJobs = createAsyncThunk(
  "getter/getJobs",
  async (params, { rejectWithValue }) => {
    try {
      return await getJobsApi(params);
    } catch (e) {
      return fail(rejectWithValue)(e);
    }
  }
);



